<template>
  <div class="description-tab">
    <div class="description-tab__input-form">
      <FormRow :modifiers="['no-padding']">
        <DescriptionFieldInput
          :currentImage="currentImage"
          :images="images"
          :issuePath="issuePath"
          @update-image-description="emitCurrentImage"
        />
      </FormRow>
    </div>
    <div class="description-tab__create-info">
      <div class="description-tab__create-info-header typo-tiny">
        {{ $t("general.image_info") }}
      </div>
      <div class="description-tab__create-info-item typo-tiny">
        <span>{{ $t("general.uploaded_date") }}:</span>
        <span>{{ formatDate(currentImage?.created_at) }}</span>
      </div>
      <div class="description-tab__create-info-item typo-tiny">
        <span>{{ $t("general.uploaded_by") }}:</span>
        <span>{{ currentImage?.created_by_name || $t("general.unknown") }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { formatDate } from '@/functions/date_format_helpers';
import FormRow from '@/components/form/row.vue';
import DescriptionFieldInput from '@/components/image_viewer/description_field_input.vue';

const props = defineProps({
  /** The currently selected image object */
  currentImage: { type: Object, required: true },
  /** The currently selected issue internal path */
  issuePath: { type: String, required: true },
  /** A list of all issue images */
  images: { type: Array, default: () => [] },
});

const emit = defineEmits(['updateImage']);

function emitCurrentImage(value) {
  let image = {...props.currentImage};

  image.description = value;

  emit('updateImage', image);
}

</script>

<style lang="scss" scoped>
@import "@/stylesheets/global";

.description-tab {
  margin-top: bu(1);

  &__input-form {
    padding-bottom: bu(1);
    border-bottom: bu(0.15) solid map-get($background-color, dark);
  }

  &__input-description {
    display: flex;
    flex-direction: column;
    width: 100%;

    textarea::placeholder {
      color: map-get($foreground-color, dark);
      font-weight: 400;
    }
  }

  &__input-description-heading {
    font-size: bu(1.8);
    padding-bottom: bu(1);
  }

  &__create-info {
    padding-top: bu(1);
    display: flex;
    flex-direction: column;
  }

  &__create-info-header {
    font-size: bu(1.8);
    font-weight: 500;
    color: map-get($foreground-color, light);
    padding: bu(1) 0;
  }

  &__create-info-item {
    display: flex;
    justify-content: space-between;
    padding-bottom: bu(1);

    span:first-of-type {
      color: map-get($foreground-color, dark);
    }

    span:last-of-type {
      color: map-get($foreground-color, light);
    }
  }

  &__modal-actions {
    padding: bu(1) 0;
    display: flex;
    justify-content: flex-end;

    .button {
      height: bu(4);
    }
  }
}
</style>
